export const theme = {
    colors: {
        primary: '#002f6c',
        secondary: '#f4981e',
        gray: '#CFD8DC',
        light: '#fff',
        dark: '#000',
    },
}